import { render, staticRenderFns } from "./Performers.vue?vue&type=template&id=66611366&"
import script from "./Performers.vue?vue&type=script&lang=js&"
export * from "./Performers.vue?vue&type=script&lang=js&"
import style0 from "./Performers.vue?vue&type=style&index=0&id=66611366&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports